<template>
  <div v-show="false">
  </div>
</template>
<script>
import Vue from 'vue';
import { baseComponents, componentBaseMixin } from '@tencent/ceiba-base-components';

// H5竖屏设计稿
const H5_DESIGN_WIDTH = 750;
export default {
  name: 'AntiLeak',
  mixins: [componentBaseMixin],
  components: {},
  data() {
    return {
      // layoutType: 'c-page-h5',
      hasHandledLogin: false,
    };
  },
  computed: {
    canvasStyle() {
      return {
        background: '#ffffff',
      };
    },
  },
  async created() {
    await this.$login.initLogin();
    // 这里 checkLogin 主要为了应对拉起第三方登录后回来页面刷新可以自动判断是否登录
    this.$store.dispatch('checkLogin');
    // this.layoutType = Vue.prototype.$actInfo.layout_type;
    // this.$store.commit('UPDATE_ACTINFO', Vue.prototype.$actInfo);
    Vue.prototype.$storeInstance = this.$store;
    this.$onLogined(async () => {
      if (this.hasHandledLogin) {
        return;
      }
      console.log('登录成功');
      this.$eventBus.$emit('ceiba:custom:events:close-user-login-popup');
      const { ret, data = {} } = await this.flowRequest({
        flowId: 186051,
        actId: Vue.prototype.$actInfo.activity_id,
      });
      const { ret: resRet } = data;
      if (resRet === 42001 || ret === 42001) {
        this.$eventBus.$emit('ceiba:custom:events:close-user-login-popup');
        this.$alert('当前用户不在白名单内！');
        return;
      }
      this.$eventBus.$emit('ceiba:custom:events:close-user-login-popup');
      this.$emit('recover-layout');
      this.hasHandledLogin = true;
    });
    this.initialize();
  },

  methods: {
    async initialize() {
      document.documentElement.style.fontSize = this.setFontSize();
      // 判断是否登录
      setTimeout(() => {
        if (!this.isLogin) {
          baseComponents.userLoginComponent.showUserLoginPopup({
            imposeLoginType: 0,
            needWXLogin: false,
          });
        }
      }, 500);
    },
    setFontSize() {
      let fontSize = '16px';
      const rootHtml = document.documentElement;
      console.log(`deviceMode=h5|clientWidth=${rootHtml?.clientWidth}|clientHeight=${rootHtml?.clientHeight}`);
      fontSize = `${100 * (rootHtml?.clientWidth / H5_DESIGN_WIDTH)}px`;
      console.log(`fontSize=${fontSize}`);
      return fontSize;
    },
  },
};
</script>

<style></style>
